import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SuperAdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F8F7F4' }}>
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p style={{ color: '#0A0A10' }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }
console.log("user", user);
  if (user.role !== 'superadmin') {
    return <Navigate to="/" />;
  }

  return children;
}

